import find from 'lodash/find';
import getOr from 'lodash/fp/getOr';

import { genEndPointGetParam, getCookie, getCountryDetail, getGaClientId, getH6, isMobile } from "./utils";
import { Search } from "../models/search";
import { Statistics } from '../models/statistics';
import { Potential } from '../models/potential';
import { Tariffs } from '../models/tariffs';
import { Regulation } from '../models/regulation';
import { Ntm } from '../models/ntm';
import { GeoMap } from '../models/geomap';
import { TradeMeasure } from '../models/tradeMeasure';
import { TradeMeasureMap } from '../models/tradeMeasureMap';
import { TariffField } from '../models/tariffField';
import { genOrderInfoApiParam } from '../pages/homepage/orderinfo';
import { Auth } from '../models/auth';
import { LocalStorage } from '../models/LocalStorage';
import { signOut } from './firebase';
import { ROOT_GLOBAL } from '../global/root';
import Env from '../environments';
import { GLOBAL_CONSTANTS } from '../global/constants';
import { MarketRanking } from '../models/marketRanking';
import { Classification } from '../models/classification';
import { Category } from '../models/Category';
import { Blog } from '../models/Blog';
import { Paging } from '../models/Paging';
import { Faq } from '../models/Faq';
import { AIClassification } from '../models/AIClassification';
import { RegulationQuery } from '../models/RegulationQuery';
import { RegulationSearchNotebook } from '../models/RegulationSearchNotebook';
const endPoint = Env.DUTY_CAST_API;
const endPointContact = Env.DUTY_CAST_CONTACT_API;

const $ = window.jQuery;

export function genHeaderApi(isFormData = false, isBearer = false, isNoToken = false, noCache = false) {
  const token = LocalStorage.getUserToken();
  const clientId = getGaClientId();
  const currency = "USD";
  const userId = LocalStorage.getUserId();
  // const location = getCurrentCountry();
  const requestId = getCookie("_foeid");
  const tf = getCookie("_tf")
  const tfid = getCookie("_tfid")
  const result = {
    "App-Platform": isMobile() ? "mobile-web" : "web",
    "App-Locale": navigator.language,
    "App-Local-Timestamp": Date.now(),
    "App-Uuid": clientId,
    "App-Currency": currency,
    "App-tf": tf,
    "App-tfid": tfid
  }

  if (requestId) {
    result["App-Req-Id"] = requestId;
  }

  if (!isFormData) {
    result["Content-Type"] = "application/json";
  }

  if (!!token && !isNoToken) {
    result["Authorization"] = isBearer ? "Bearer " + token : token;
  }

  if (!!userId) {
    result["App-Id"] = userId;
  }

  if (noCache) {
    result['cache-control'] = 'no-cache';
    result['pragma'] = 'no-cache';
  }
  return result;
}

export function callApi(url, data, type = "POST", headers = {}, successCallBack, errorCallBack, isFormData = false) {
  return window.$.ajax({
    url: url,
    type: type,
    dataType: isFormData ? undefined : 'json',
    headers: headers,
    processData: false,
    contentType: isFormData ? false : 'application/json',
    success: function (data) {
      if (typeof successCallBack === "function") {
        successCallBack(data);
      } else {
        console.error(data);
      }
    },
    error: function (xhr, status, error) {
      try {
        const errorObj = JSON.parse(xhr.responseText);
        const errorCode = getOr('', 'error_code')(errorObj);
        if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.EXPIRE_TOKEN) {
          refreshToken(() => callApi(url, data, type, updateHeaderToken(headers), successCallBack, errorCallBack, isFormData));
          return;
        }
        if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.INVALID_TOKEN) {
          signOut(undefined, undefined, Auth.callBackLogin());
        }
        if (typeof errorCallBack === "function") {
          errorCallBack(errorObj);
        } else {
          console.error(errorObj);
        }
      } catch (error) {
        if (typeof errorCallBack === "function") {
          errorCallBack(xhr.responseText);
        } else {
          console.error(xhr.responseText);
        }
      }

    },
    data: isFormData ? data : JSON.stringify(data)
  });
}

function updateHeaderToken(header) {
  const result = {
    ...header
  }
  if (header && typeof header === "object" && header["Authorization"]) {
    const token = LocalStorage.getUserToken();
    result["Authorization"] = header["Authorization"].indexOf("Bearer") !== -1 ? "Bearer " + token : token;
  }
  return result;
}

export function hsSearch(exportCountry, destination, hs = "", onSuccess, onError, apiTime) {
  if (window.hsSearch && typeof window.hsSearch.abort === "function") {
    window.hsSearch.abort();
  }
  const param = {
    hsRev: window.hsRev,
    "p": 1,
    "pp": 7,
    "fl": 0,
    "ftfs": ["ftb", "ct"],
    "t": hs,
    // "f[v]": ["h6"],
    exportCountry: getCountryDetail(exportCountry).iso2,
    country: getCountryDetail(destination).iso2
  };

  if (!isNaN(hs * 1)) {
    param["ftfs"] = ["ct"];
    param["s[id]"] = "asc";
  }
  return window.hsSearch = callApi(
    endPoint + "/search",
    param,
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Search.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function getHsVersion(destination, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPoint + "/latest-hs-rev-for-tariffs", {
      reporter: getCountryDetail(destination).code
    }),
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = getOr(window.hsRev, "data.hsRevision.revCode")(data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function tradeStatistics(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPoint + "/trade-statistics", {
      reporter: getCountryDetail(params.destination).code,
      partner: getCountryDetail(params.export).code,
      product: getH6(params.hs),
      hsRev: window.hsRev
    }),
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Statistics.fromApiObject(data, getH6(params.hs));
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function potential(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPoint + "/import-potential", {
      reporter: getCountryDetail(params.destination).code,
      partner: getCountryDetail(params.export).code,
      product: getH6(params.hs),
      hsRev: window.hsRev
    }),
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const arr = data.data.available;
          const result = Potential.fromApiObject(find(arr, function (o) { return o.ctyCode * 1 === getCountryDetail(params.destination).code * 1; }));
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function tariffs(params, currency, onSuccess, onError, apiTime) {
  const type = $(".section-import-tax").attr("type") || "minimum_rate";
  let query = {
    hs_code: params.hs,
    destination: getCountryDetail(params.destination).iso2,
    origin: getCountryDetail(params.export).iso2,
    currency: currency,
    custom_param: {},
    mode: type
  };
  window.orderInfo?.length && window.orderInfo.forEach(element => {
    query = genOrderInfoApiParam(query, element, params)
  });

  if (type === "customize") {
    $(".section-import-tax .requirement .content .item input:checked[param]").each(function (i, obj) {
      const code = $(obj).attr("param");
      query.custom_param[code] = $(obj).attr("name");
    });
  }

  return callApi(
    // endPoint + "/calculated_tariff",
    endPoint + "/v2/tariff",
    query,
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const obj = data;
          const result = Tariffs.fromApiObject(obj, currency);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function exportRequirement(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPoint + "/market-export-ntm", {
      reporter: getCountryDetail(params.destination).code,
      partner: getCountryDetail(params.export).code,
      product: getH6(params.hs),
      hsRev: window.hsRev
    }),
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const regulationReferences = Regulation.fromApiArray(getOr([], "data.available.referenceData.regulationReference")(data));
          const ntmReferences = Ntm.fromApiArray(getOr([], "data.available.referenceData.ntmReference")(data));
          let temp = Object.values(getOr({}, "data.available.data")(data));
          const result = Ntm.fromApiArray(getOr([], "[0].ntmSections[0].ntmGroups")(temp), ntmReferences, regulationReferences, "domesticRegulations");
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function importRequirement(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPoint + "/market-import-ntm", {
      reporter: getCountryDetail(params.destination).code,
      partner: getCountryDetail(params.export).code,
      product: getH6(params.hs),
      hsRev: window.hsRev
    }),
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const regulationReferences = Regulation.fromApiArray(getOr([], "data.available.referenceData.regulationReference")(data));
          const ntmReferences = Ntm.fromApiArray(getOr([], "data.available.referenceData.ntmReference")(data));
          let temp = Object.values(getOr({}, "data.available.data")(data));
          const ntmSections = getOr([], "[0].ntmSections")(temp);
          const productRegulations = Ntm.fromApiArray(getOr([], "ntmGroups")(find(ntmSections, { sectionNameKey: "productRegulations" })), ntmReferences, regulationReferences, "productRegulations");
          const marketRequirements = Ntm.fromApiArray(getOr([], "ntmGroups")(find(ntmSections, { sectionNameKey: "marketRequirements" })), ntmReferences, regulationReferences, "marketRequirements");
          const preshipmentCertifications = Ntm.fromApiArray(getOr([], "ntmGroups")(find(ntmSections, { sectionNameKey: "preshipmentCertifications" })), ntmReferences, regulationReferences, "preshipmentCertifications");
          typeof (onSuccess) === "function" && onSuccess({
            productRegulations,
            marketRequirements,
            preshipmentCertifications
          });
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function getMapData(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPoint + "/export-potential", {
      country: getCountryDetail(params.export).code,
      product: getH6(params.hs)
    }),
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = GeoMap.fromApiArray(data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function apiContact(data, onSuccess, onError, apiTime) {
  return callApi(endPointContact + "/api/v2/landing_pages",
    data,
    "POST", genHeaderApi(false, false, true), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiSendToEmail(data, onSuccess, onError, apiTime) {
  return callApi(endPoint + "/report",
    data,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function imageSearch(exportCountry, destination, file, onSuccess, onError, apiTime) {
  const fdata = new FormData();
  fdata.append('file', file);
  return callApi(
    genEndPointGetParam(endPoint + "/image_search", {
      "p": 1,
      "pp": 7,
      exportCountry: getCountryDetail(exportCountry).iso2,
      country: getCountryDetail(destination).iso2
    }),
    fdata,
    "POST",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Search.fromApiArray(JSON.parse(data).data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function tariffFields(data, onSuccess, onError, apiTime) {
  return callApi(endPoint + "/tariff_fields",
    {
      ...data,
      destination: getCountryDetail(data.destination).iso2,
      origin: getCountryDetail(data.origin).iso2,
    },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = TariffField.fromApiArray(data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function tradeMeasure(onSuccess, onError, apiTime) {
  return callApi(
    endPoint + "/covid_trade_measure",
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = TradeMeasure.fromApiArray(data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function tradeMeasureMap(onSuccess, onError, apiTime) {
  return callApi(
    endPoint + "/covid_trade_map",
    undefined,
    "GET",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = TradeMeasureMap.fromApiArray(data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function callLoginApi(params, onSuccess, onError, apiTime) {
  return callApi(
    `${endPoint}/login`,
    params,
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Auth.fromApiObject(getOr({}, 'data')(data));
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      console.error(error);
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export const handleTokenError = () => {
  return signOut(function () {
    window.location.href = `${ROOT_GLOBAL.LOGIN}&cb=${encodeURIComponent(window.location.href)}`
  }, function () {
    window.location.href = `${ROOT_GLOBAL.LOGIN}&cb=${encodeURIComponent(window.location.href)}`
  });
}

export function refreshToken(callback) {
  return callApi(
    `${endPoint}/refresh_token`,
    {
      "refresh_token": LocalStorage.getRefreshToken()
    },
    "POST",
    genHeaderApi(),
    function (data) {
      try {
        const result = Auth.fromApiObject(data.data);
        if (result.isVaildAuth()) {
          result.saveLoginInfo();
          typeof (callback) === "function" && callback();
        } else {
          handleTokenError();
        }
      } catch (error) {
        console.error(error);
        handleTokenError(error);
      }
    },
    function (error) {
      console.error(error);
      handleTokenError(error);
    }
  );
}

export function upgrade(param = {}, onSuccess, onError, apiTime) {
  return callApi(
    endPoint + "/upgrade",
    param,
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Auth.fromApiObject(data.data);
          if (result.isVaildAuth()) {
            result.saveLoginInfo();
            typeof (onSuccess) === "function" && onSuccess();
          } else {
            handleTokenError();
          }
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function logoutApi(onSuccess, onError, apiTime) {
  return callApi(
    `${endPoint}/logout`,
    {},
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess();
      }
    },
    function (error) {
      console.error(error);
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function expirePackageApi() {
  return callApi(
    `${endPoint}/testing/expire_package`,
    {},
    "POST",
    genHeaderApi(),
    function (data) {
      signOut(undefined, undefined, Auth.callBackLogin());
    },
    function (error) {
      console.error(error);
    }
  );
}

window.dfgxcv123sdasw = expirePackageApi;

export function marketRank(data, onSuccess, onError, apiTime) {
  return callApi(endPoint + "/market_ranking",
    {
      ...data,
      product: getH6(data.product)
    },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = MarketRanking.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function classification(destination, product, file, description, onSuccess, onError, apiTime) {
  const fdata = new FormData();
  fdata.append('destination', getCountryDetail(destination).iso2);
  if (file) {
    fdata.append('file', file);
  }
  if (product) {
    const checkNum = product.replace(/[^a-zA-Z0-9]/g, "");
    if (isNaN(checkNum)) {
      fdata.append('title', product);
    } else {
      fdata.append('title', checkNum);
    }
  }
  if (description) {
    fdata.append('description', description);
  }
  return callApi(
    endPoint + "/v2/classify",
    fdata,
    "POST",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Classification.fromApiArray(JSON.parse(data).data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function aiclassify(params, onSuccess, onError, apiTime) {
  let query = {
    destination: getCountryDetail(params.destination).iso2,
    origin: getCountryDetail(params.export).iso2,
    term: params.hs || params.product,
    parent_code: params.parent || ""
  };

  return callApi(
    endPoint + "/v2/aiclassify",
    JSON.stringify(query),
    "POST",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = AIClassification.fromApiObject(JSON.parse(data));
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function commodity(destination, hsCode, origin, mode, currency, onSuccess, onError, apiTime) {
  const params = {
    destination: getCountryDetail(destination).iso2,
    hs_code: hsCode,
    origin: getCountryDetail(origin).iso2,
    mode: mode
  }
  return callApi(
    endPoint + "/v2/commodity",
    JSON.stringify(params),
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const obj = data;
          const result = Tariffs.fromApiObject(obj, currency);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}


export function calculateTariff(params, currency, onSuccess, onError, apiTime) {
  let query = {
    hs_code: params.hs,
    destination: getCountryDetail(params.destination).iso2,
    origin: getCountryDetail(params.export).iso2,
    currency: currency,
    custom_param: {},
    mode: params.mode,
  };
  window.orderInfo?.length && window.orderInfo.forEach(element => {
    query = genOrderInfoApiParam(query, element, params)
  });

  query.unit = query.custom_param;
  delete query.custom_param;

  return callApi(
    endPoint + "/v2/calculate_tariff",
    JSON.stringify(query),
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const obj = data;
          const result = Tariffs.fromApiObject(obj, currency);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function products(destination, parent, level, onSuccess, onError, apiTime) {
  const params = {
    destination: getCountryDetail(destination).iso2,
    p: 1,
    pp: 1000
  }
  if (parent) {
    params.parents = parent;
  }
  if (level) {
    params.levels = level;
  }
  return callApi(
    endPoint + "/products",
    JSON.stringify(params),
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Classification.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function categories(onSuccess, onError, apiTime) {
  return callApi(endPoint + "/blog_categories",
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Category.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function blogs(params, onSuccess, onError, apiTime) {
  return callApi(genEndPointGetParam(endPoint + "/blogs", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Blog.fromApiArray(data.data);
          const paging = Paging.fromApiObject(data.paging);
          typeof (onSuccess) === "function" && onSuccess(result, paging);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function blogDetail(id, onSuccess, onError, apiTime) {
  return callApi(`${endPoint}/blogs/${id}`,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Blog.fromApiObject(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function blogRelative(id, onSuccess, onError, apiTime) {
  return callApi(`${endPoint}/blogs/${id}/related`,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Blog.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function faq(params, onSuccess, onError, apiTime) {
  return window.hsSearch = callApi(genEndPointGetParam(endPoint + "/faqs", params),
    undefined,
    "GET", genHeaderApi(false, false, true), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Faq.fromApiArray(data.data);
          const paging = Paging.fromApiObject(data.paging);
          typeof (onSuccess) === "function" && onSuccess(result, paging);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUkBookMeeting(data, onSuccess, onError, apiTime) {
  return callApi(endPoint + "/me/form_requests",
    data,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCheckMeeting(params, onSuccess, onError, apiTime) {
  return callApi(genEndPointGetParam(endPoint + "/me/form_request", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiBookDemo(params, onSuccess, onError, apiTime) {
  return callApi(endPoint + "/form/book-demo",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiRegulationQuery(params, onSuccess, onError, apiTime) {
  let query = {
    destination: getCountryDetail(params.destination).iso2,
    hs_code: params.hs,
    query: params.query,
    step: params.step,
    notebook_ids: params.notebook_ids
  };

  return callApi(
    endPoint + "/v2/regulation/query",
    JSON.stringify(query),
    "POST",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = RegulationQuery.fromApiObject(JSON.parse(data).data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function apiRegulationSearchNotebook(params, onSuccess, onError, apiTime) {
  let query = {
    destination: getCountryDetail(params.destination).iso2,
    hs_code: params.hs
  };

  return callApi(
    genEndPointGetParam(endPoint + "/v2/regulation/notebook", query),
    undefined,
    "GET",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = RegulationSearchNotebook.fromApiArray(JSON.parse(data).data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function apiGenAIChatCompletion(params, onSuccess, onError, apiTime) {
  let body = {
    args: params.args
  };

  return callApi(
    endPoint + "/v2/genai/chat/completions",
    JSON.stringify(body),
    "POST",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = JSON.parse(data).data;
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function apiSaveToNotebook(params, onSuccess, onError, apiTime) {
  let body = {
    notebook_id:    params.notebook_id,
    string_filter:  params.string_filter,
    sources:        params.sources
  };

  return callApi(
    endPoint + "/v2/notebookllm/add_source",
    JSON.stringify(body),
    "POST",
    genHeaderApi(true),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = JSON.parse(data).data;
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    },
    true
  );
}

export function apiGetBannerOntop(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_BANNER_ON_TOP,
    undefined,
    "GET", 
    genHeaderApi(), 
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
  );
}